import { Component } from "@angular/core"
import { AlertController, ViewController, LoadingController, ToastController } from "ionic-angular"

import firebase from "firebase"

@Component({
  selector: "profile-password-page",
  templateUrl: "password.html",
})
export class ProfilePasswordPage {

  currentPassword = ""
  newPassword = ""
  confirmPassword = ""

  constructor(
    private alertCtrl: AlertController,
    private viewCtrl: ViewController,
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController
  ) {}

  onCancel() {
    this.viewCtrl.dismiss()
  }

  onUpdate() {

    if (!this.validData())
      return

    const loading = this.loadingCtrl.create({ content: "Por favor, aguarde..." })

    loading.present()

    const user = firebase.auth().currentUser

    firebase.auth().signInWithEmailAndPassword(user.email, this.currentPassword)
      .then(() => user.updatePassword(this.newPassword))
      .then(() => {

        loading.dismiss()
        this.viewCtrl.dismiss()

        this.toastCtrl.create({
          message: "Senha alterada com sucesso",
          duration: 3000,
        }).present()
      })
      .catch((error: any) => {

        console.log(error)

        let message = "Falha ao redefinir senha"

        if (error.toJSON().code == "auth/wrong-password")
          message = "Senha atual inválida"

        loading.dismiss()

        this.alertCtrl.create({
          message,
          buttons: ["Ok"]
        }).present()
      })
  }

  validData() {

    let message = ""
    let isOk = true

    if (!this.currentPassword) {
      message = "Por favor informe sua senha atual"
    } else if (!this.newPassword) {
      message = "Por favor defina uma nova senha"
    } else if (this.newPassword.length < 6) {
      message = "Sua nova senha deve possuir ao menos 6 caracteres"
    } else if (!this.confirmPassword) {
      message = "Por favor confirme sua nova senha"
    } else if (this.newPassword != this.confirmPassword) {
      message = "Senha não confirmada corretamente"
    }

    if (message) {
      isOk = false
      this.alertCtrl.create({
        message,
        buttons: ["Ok"]
      }).present()
    }

    return isOk
  }

  onForgotPassword() {

    this.alertCtrl.create({
      title: "Recuperação de senha",
      message: "Deseja receber um e-mail para redefinir sua senha ?",
      buttons: [
        {
          text: "Enviar",
          handler: () => this.sendPasswordResetEmail(),
        },
        {
          text: "Cancelar",
          role: "cancel",
        }
      ]
    }).present()
  }

  sendPasswordResetEmail() {

    const loading = this.loadingCtrl.create({ content: "Por favor, aguarde..." })

    loading.present()

    const email = firebase.auth().currentUser.email

    firebase.auth().sendPasswordResetEmail(email)
      .then(() => {

        loading.dismiss()

        this.toastCtrl.create({
          message: "E-mail enviado para " + email,
          duration: 3000,
        }).present()
      })
      .catch((error) => {

        console.log(error)

        loading.dismiss()

        this.alertCtrl.create({
          title: "Falha ao enviar e-mail",
          message: "Por favor tente novamente em alguns minutos",
          buttons: ["Ok"],
        }).present()
      })
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/password.ts